import { useAppDispatch } from '../../hooks/redux'
import { setUser as setUserRedux } from '../../redux/slice/user'
// import { useGoogleLogin } from '@react-oauth/google'
import { useNavigate } from 'react-router-dom'
// import { GoogleLogo } from '../../assets/icons/googleLogo'
import http from '../../api/http'
import { useState } from "react"
import {
  Container,
  Body,
  Title,
  GoogleSignIn,
  HiddenGoogleAuth,
  ErrMsg
} from './Login.style'
import { Button, Link, Paper, Box, Typography, Alert, TextField, Checkbox, FormControlLabel, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'

export type UserLoginT = {
  user: string
  password: string
}

interface ErrorResponse {
  response?: {
    data?: {
      msg?: string;
      message?: string;
      errors?: string[];
      error?: string;
    };
  };
}

const login = async (email: string, password: string, rememberMe: boolean) => {
  const res = await http.post('/api/admins/auth/login', { email, password });
  return res.data;
};

const Login = () => {
  const [err, setErr] = useState<any>('')
  const [errorList, setErrorList] = useState<string[]>([])
  const [errorDetail, setErrorDetail] = useState<string>('')
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  })
  const [rememberMe, setRememberMe] = useState(() => !!localStorage.getItem('accessToken'))
  const [errors, setErrors] = useState({
    email: '',
    password: '',
  })
  const [isLoading, setIsLoading] = useState(false)
  const [forgotOpen, setForgotOpen] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotMsg, setForgotMsg] = useState('');
  const [forgotErr, setForgotErr] = useState('');

  // const googleLogin = useGoogleLogin({
  //   onSuccess: (tokenResponse) => {
  //     LoginWithGoogle(tokenResponse);
  //   },
  //   onError: () => {
  //     setErr('Fail to Login, please try again');
  //     console.log('Login Failed');
  //   },
  //   flow: 'implicit',
  // });

  // const LoginWithGoogle = async (token: any) => {
  //   setErr('')
  //   try {
  //     const { credential } = token
  //     const res = await http.post('/api/login', { token: credential }, {})
  //     dispatch(setUserRedux(res.data))
  //     navigate('/create-theme')
  //   } catch (error: any) {
  //     const typedError = error as ErrorResponse;
  //     console.log('error4444', error)
  //     setErr(typedError?.response?.data?.msg || 'Wrong Email to Login')
  //   }
  // }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = { email: '', password: '' };

    if (!formData.email) {
      newErrors.email = 'Email is required';
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
      isValid = false;
    }

    if (!formData.password) {
      newErrors.password = 'Password is required';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        setIsLoading(true);
        setErr('');
        setErrorList([]);
        setErrorDetail('');
        const response = await login(formData.email, formData.password, rememberMe);
        dispatch(setUserRedux(response.admin));
        localStorage.setItem('accessToken', response.token);
        navigate('/admin/dashboard');
      } catch (error: any) {
        const typedError = error as ErrorResponse;
        const apiMsg = typedError?.response?.data?.message;
        const apiErrors = typedError?.response?.data?.errors;
        const apiErrorDetail = typedError?.response?.data?.error;
        setErr(apiMsg || 'Login failed');
        setErrorList(Array.isArray(apiErrors) ? apiErrors : []);
        setErrorDetail(apiErrorDetail || '');
        console.error('Login failed:', error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleForgot = async (e: React.FormEvent) => {
    e.preventDefault();
    setForgotMsg('');
    setForgotErr('');
    setForgotLoading(true);
    try {
      await http.post('/api/users/auth/forgot-password', { email: forgotEmail });
      setForgotMsg('If this email exists, a reset link has been sent.');
      setForgotLoading(false);
    } catch (error: any) {
      setForgotErr('Failed to send reset email.');
      setForgotLoading(false);
    }
  };

  const handleRememberMe = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRememberMe(e.target.checked);
  };

  return (
    <div>
      <Container>
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: 2
          }}
        >
          <Typography component="h1" variant="h4">
            Sign in
          </Typography>
          <Paper
            elevation={3}
            sx={{
              marginTop: '40px',
              padding: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: 550,
              maxWidth: 550,
              boxSizing: 'border-box'
            }}
          >
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={formData.email}
                onChange={handleChange}
                error={!!errors.email}
                helperText={errors.email}
                disabled={isLoading} 
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={formData.password}
                onChange={handleChange}
                error={!!errors.password}
                helperText={errors.password}
                disabled={isLoading}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                disabled={isLoading}
              >
                {isLoading ? 'Signing in...' : 'Sign In'}
              </Button>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <FormControlLabel
                  control={<Checkbox checked={rememberMe} onChange={handleRememberMe} />}
                  label="Remember me"
                />
              </Box>

              {err && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {err}
                  {errorDetail && (
                    <div style={{ fontSize: 13, color: '#b71c1c', marginTop: 4 }}>{errorDetail}</div>
                  )}
                  {errorList.length > 0 && (
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                      {errorList.map((e, i) => (
                        <li key={i}>{e}</li>
                      ))}
                    </ul>
                  )}
                </Alert>
              )}
            </Box>
          </Paper>
        </Box>
      </Container>
      <Dialog open={forgotOpen} onClose={() => {
        setForgotOpen(false);
        setForgotEmail('');
        setForgotMsg('');
        setForgotErr('');
        setForgotLoading(false);
      }}>
        <DialogTitle>Reset password</DialogTitle>
        <DialogContent sx={{ minWidth: { xs: '100vw', sm: 400 }, p: 3 }}>
          <Box component="form" onSubmit={handleForgot} sx={{ mt: 1 }}>
            <TextField
              autoFocus
              margin="dense"
              label="Email Address"
              type="email"
              fullWidth
              value={forgotEmail}
              onChange={e => setForgotEmail(e.target.value)}
              required
            />
            {forgotMsg && <Alert severity="success" sx={{ mt: 2 }}>{forgotMsg}</Alert>}
            {forgotErr && <Alert severity="error" sx={{ mt: 2 }}>{forgotErr}</Alert>}
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          {forgotMsg ? (
            <Button onClick={() => {
              setForgotOpen(false);
              setForgotEmail('');
              setForgotMsg('');
              setForgotErr('');
              setForgotLoading(false);
            }} variant="contained">Close</Button>
          ) : (
            <>
              <Button onClick={() => setForgotOpen(false)}>Cancel</Button>
              <Button onClick={handleForgot} disabled={forgotLoading} variant="contained">
                {forgotLoading ? 'Sending...' : 'Send reset link'}
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default Login
